import { Component, OnInit } from "@angular/core";
import {
    SearchHistoryItem,
    SearchHistoryService,
} from "../search-history.service";

@Component({
    selector: "app-search-recent-actions",
    templateUrl: "./search-recent-actions.component.html",
    styleUrls: ["./search-recent-actions.component.scss"],
})
export class SearchRecentActionsComponent implements OnInit {
    history$ = this.searchHistoryService.getHistory();
    constructor(private searchHistoryService: SearchHistoryService) {}

    ngOnInit(): void {}

    clearHistory(){
        this.searchHistoryService.clearHistory()
    }
}
